export default function prepareDates(dates) {
  const realDates = dates.map(([date, price]) => {
    return [new Date(date), price];
  });

  const months = [];
  realDates.forEach((pair, i, arr) => {
    if (i === 0) {
      months.push({
        month: pair[0].getMonth(),
        dates: [pair],
      });
    } else {
      const prevDate = arr[i - 1][0];
      if (pair[0].getMonth() === prevDate.getMonth()) {
        const lastMonth = months[months.length - 1];
        lastMonth.dates.push(pair);
      } else {
        months.push({
          month: pair[0].getMonth(),
          dates: [pair],
        });
      }
    }
  });

  const years = [];
  months.forEach((month, i, arr) => {
    if (i === 0) {
      years.push({
        year: month.dates[0][0].getFullYear(),
        months: [month],
      });
    } else {
      const prevDate = arr[i - 1].dates[0][0];
      if (month.dates[0][0].getFullYear() === prevDate.getFullYear()) {
        const lastYear = years[years.length - 1];
        lastYear.months.push(month);
      } else {
        years.push({
          year: month.dates[0][0].getFullYear(),
          months: [month],
        });
      }
    }
  });

  let minPrice = Infinity;
  let maxPrice = 0;

  dates.forEach(([, price]) => {
    if (price) {
      maxPrice = price > maxPrice ? price : maxPrice;
      minPrice = price < minPrice ? price : minPrice;
    }
  });

  return {
    minPrice,
    maxPrice,
    years,
  };
}
